import React, { useEffect, useMemo } from "react";
import MomentUtils from "@date-io/moment";
import "moment/locale/uk";
import CalendarTodayOutlined from '@material-ui/icons/CalendarTodayOutlined'

// @ts-ignore
import {locale}from "moment";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import classNames from "classnames";
import {FieldAttributes, useField, useFormikContext} from "formik";
import {FormControl} from "@material-ui/core";
import {IFormattedResponse} from "../../../model/parametrizedResponse";
import {IResponseField} from "../../../model/reactField";
import "./index.scss";

interface Props {
    placeholder: string;
    label: string;
    minDate?: Date;
    maxDate?: Date;
    onChangeListener?: (val: any) => void;
    disabled: boolean;
    hidden: boolean;
    error?: boolean;
    errorMessage?: string;
    backEndName?: string;
    setFieldToUpdate?: (fieldToUpdate: IResponseField) => void;
    formatResponse: (obj: any) => IFormattedResponse;
    defaultValue?: any;
    contextPath?: string;
    defaultFieldNotRequired?: boolean; //todo Удалить этот атрибут. Переделать что бы при получении meta информации - получали список персон, а не одну. RFC-55568
}

export const DateSelectOld = (props: FieldAttributes<Props>) => {
    const {name, label, placeholder, disabled, hidden, error, errorMessage, backEndName, setFieldToUpdate,
        formatResponse, contextPath, defaultValue, defaultFieldNotRequired} = props;
    const {minDate, maxDate, onChangeListener} = props;

    const [field, meta, helpers] = useField({name});
    const validationError = meta.error && meta.touched ? meta.error : "";

    const helperText = useMemo(() => {
        if (validationError !== '') return validationError;
        if (error) return errorMessage;
        return "";
    }, [validationError, error, errorMessage]);

    useEffect(() =>{
        if(!defaultFieldNotRequired && defaultValue) {
            helpers.setValue(defaultValue);
        }
    }, [defaultFieldNotRequired, defaultValue]);

    const locLocale=()=>{
        if(process.env.REACT_APP_LANG==='ua') {
            return locale('uk');
        }else {
            return locale('en');
        }
    }

    const {handleBlur} = useFormikContext();

    const onChange = (date: any) => {

        let formattedValue;
        let isValid = true;
        if (date) {
            if (date.isValid()) {
                formattedValue = formatResponse(date);

            } else {
                formattedValue = {quotationValue: date, value: date};
                isValid = false;
            }
        } else {
            formattedValue = {quotationValue: null, value: null};
        }

        if (onChangeListener) {
            onChangeListener(date);
        }
        helpers.setValue(formattedValue.quotationValue);

        if(isValid && setFieldToUpdate && backEndName){
            setFieldToUpdate({name: backEndName, value: formattedValue.value, contextPath : contextPath? contextPath: 'mainContract'});
        }
    };

    const className = classNames({
        "date-select": true,
    });

    return (
        <FormControl className={'select-one-input__select'} error={validationError !== '' || (errorMessage !== null && errorMessage !==  '')} variant="outlined" fullWidth={true}>
            <MuiPickersUtilsProvider utils={MomentUtils} locale={locLocale()}>
            <div className={className} hidden={hidden}>
                <div className={'date-select__input'}>
                    <KeyboardDatePicker
                                        value={field.value}
                                        id={name}
                                        autoOk
                                        variant="inline"
                                        minDate={minDate !== null ? minDate : undefined}
                                        maxDate={maxDate !== null ? maxDate : undefined}
                                        label={label}
                                        InputLabelProps={{
                                            style: {
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                width: '92%'
                                            }
                                        }}
                                        inputVariant="outlined"
                                        placeholder={placeholder}
                                        fullWidth={true}
                                        format={"DD.MM.YYYY"}
                                        disabled={disabled}
                                        helperText={helperText}
                                        error={error || validationError !== ''}
                                        onChange={onChange}
                                        onBlur={handleBlur}
                                        keyboardIcon={<CalendarTodayOutlined htmlColor={'#9E9C9A'}/>}
                                        PopoverProps={{
                                            transitionDuration: 0,
                                        }}
                                        />
                </div>
            </div>
            </MuiPickersUtilsProvider>
        </FormControl>
    )
};
